<template>
  <router-view/>
  <notifications
      group="foo-css"
      position="bottom right"
      :speed="500"
  />

  <!-- Custom style example -->
  <notifications
      group="custom-style"
      position="bottom left"
      classes="n-light"
      :max="3"
      :width="400"
  />

  <!-- Custom template example -->
  <notifications
      group="custom-template"
      :duration="6000"
      :width="this.layoutStore.isDesktop ? 400 : '90%'"
      :position="this.layoutStore.isDesktop ? 'bottom left' : 'bottom center'"
      style="z-index: 9999;"
  >
    <template #body="{ item }">
      <transition appear enter-active-class="animated slideInLeft"
                  leave-active-class="animated slideOutLeft" :duration="2000">

        <q-card dark :class="'border-'+item.type">
          <q-toolbar class="custom-template-title">
            <q-item-label>
              <q-icon color="white" size="md" :name="computeIcon(item.type)"/>
              {{ item.title }}
            </q-item-label>
            <q-space></q-space>
            <q-btn
                round
                flat
                dense
                icon="close"
                color="grey-8"
                @click="close(item.id)"
            ></q-btn>
          </q-toolbar>

          <q-separator dark></q-separator>

          <q-card-section>
            <q-item v-if="item.type==='information'" class="custom-template-content-information">
              <q-item-section>
                <div
                    class="custom-template-text"
                    v-html="item.text"
                />
              </q-item-section>

            </q-item>
            <q-item v-else-if="item.type==='warning'" class="custom-template-content-warning">
              <q-item-section>
                <div
                    class="custom-template-text"
                    v-html="item.text"
                />
              </q-item-section>

            </q-item>
            <q-item v-else-if="item.type==='error'" class="custom-template-content-error">

              <q-item-section>
                <div
                    class="custom-template-text"
                    v-html="item.text"
                />
              </q-item-section>

            </q-item>
          </q-card-section>

        </q-card>

      </transition>
    </template>
  </notifications>


</template>

<script>
import {defineComponent} from 'vue';
import EventBus from "src/services/utils/appEventBusService"
import {useLayoutStore} from "stores/layoutStore";
import {mapStores} from "pinia";

export default defineComponent({
  name: 'App',
  inject: ["notify"],
  data() {
    return {
      id: 0
    };
  },
  methods: {
    computeIcon(type) {
      if(type==='information') {
        return "info"
      }
      else if(type==='warning'){
        return "warning"
      }
      else {
        return "error"
      }
    },
    close(id) {
      this.notify.close(id)
    },
    show(options) {
      const group = options.group
      const title = options.title
      const text = options.message
      const type = options.type
      this.notify({
        group,
        title: title,
        text,
        type,
        data: {
          randomNumber: Math.random(),
        },
        close: true,
        ignoreDuplicates: true,
        pauseOnHover : true,
      });
    },

    clean(group) {
      this.notify({group, clean: true});
    },
  },
  computed: {
    ...mapStores(useLayoutStore)
  },
  created() {
    EventBus.on('notify', (notification) => {
      this.show(notification)
    })
  }
});
</script>

<style lang="scss">


.custom-template-content-information {
  vertical-align: center;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  font-size: 16px;
  width: auto;
  text-wrap: normal;

}

.custom-template-content-warning{
  vertical-align: center;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  font-size: 18px;
  width: auto;
  text-wrap: normal;

}

.custom-template-content-error {
  vertical-align: center;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  font-size: 18px;
  width: auto;
  text-wrap: normal;

}

/* Texte des notifications : à la largeur de la notification (90 % de l'écran sur téléphone), avec retour à la
   ligne, même au milieu d'un mot long */
.custom-template-text {
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}

.custom-template-title {
  font-size: 16px;
  padding-left: 10px;
  color: white;
}

.border-information {
  border: 1px solid #1af6f6;
  border-left: 5px solid #1af6f6;
  margin: 10px;
  top:10px
}

.border-warning {
  border: 1px solid orange;
  border-left: 5px solid orange;
  margin: 10px;
  top:10px
}

.border-error {
  border: 1px solid red;
  border-left: 5px solid red;
  margin: 10px;
  top:10px
}


</style>
